<template>
  <section class="content-center-full-height" :class="[theme]">
    <grid direction="stack" horizontal="center" class="view-wrapper">
      <header v-if="logo">
        <router-link :to="{ name: logoRouteName }">
          <img
            src="/static/images/logos/bi-logo-rainbow-white-RGB.svg"
            v-if="logoWhite"
            alt="Bohemia Interactive"
            class="logo"
            width="300"
            height="112"
          />
          <img
            src="/static/images/logos/bi-logo-rainbow-black-RGB.svg"
            v-else
            alt="Bohemia Interactive"
            class="logo"
            width="300"
            height="112"
          />
        </router-link>
        <slot name="headerBottom">
          <Divider size="3em" />
        </slot>
      </header>
      <slot></slot>
    </grid>
  </section>
</template>

<script>
export default {
  name: "page-wrapper",
  props: {
    logo: {
      type: Boolean,
      default: false
    },
    routeName: {
      type: String
    },
    theme: {
      type: String,
      default: "greyframe"
    },
    logoWhite: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    logoRouteName() {
      return this.routeName || this.pages.AUTH_LOGIN;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.view-wrapper {
  padding: 2em 0 1em;
  display: flex;
  flex: 1;
  align-items: center;
}

.embedded {
  .view-wrapper {
    padding: 0;
  }
}

.logo {
  max-width: 300px;
  height: auto;
}
</style>
